import Vue from 'vue';

import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import './filters';
import './directives';
import './addons';
import { auth } from './firebase';

Vue.config.productionTip = false;

/* eslint-disable import/no-mutable-exports */
let app;

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      i18n,
      store,
      components: { App },
      template: '<App/>',
    });
  }
});

export default app;



// WEBPACK FOOTER //
// ./src/main.js